import type { CmsMedia } from "@/types/strapi";
import React, { ReactElement } from "react";
import styles from "./OfferHeaderAttribution.module.css";
import { CmsImage } from "@/components/common/CmsImage";

export const OfferHeaderAttribution = ({
    attributionTitle,
    attributionSubTitle,
    logo,
}: {
    attributionTitle: string | undefined;
    attributionSubTitle: string | undefined;
    logo: CmsMedia | null;
}): ReactElement | null => {
    return (
        <div className={styles.container}>
            {attributionTitle ? (
                <div className={styles.attributionTitle}>
                    {attributionTitle}
                </div>
            ) : null}

            <div
                className={[
                    styles.imgWrapper,
                    styles[attributionTitle ? "leftMargin" : ""],
                ].join(" ")}
            >
                {logo?.data?.attributes && (
                    <CmsImage cmsMedia={logo} desiredHeight={25} loading="eager"/>
                )}
            </div>

            {attributionSubTitle ? (
                <div className={styles.attributionTitle}>
                    {attributionSubTitle}
                </div>
            ) : null}
        </div>
    );
};
